import React from 'react';

import epochs from '~/kits/general/config';
import Epoch from '~/kits/general/scripts/Epoch';
import Chart from '~/kits/general/scripts/Chart';
import useActiveItem from './useActiveItem';
import Icon from '~/core/scripts/components/Icon';
import { is768Query } from '~/core/scripts/mediaquery-helper';
import ChartTitle from '~/kits/general/scripts/ChartTitle';

const isSmallScreen = !is768Query();

const Headline = () => (
  <div className="headline">
    <div className="topline">
      {/* <time className="date">01.01.2016</time> */}
      <span className="kicker">Sonntagsfragen seit 2013</span>
    </div>
    <h1 className="title">Wann die AfD gewinnt - und verliert</h1>
    <h2 className="introtext">
      Die AfD ist bei den Landtagswahlen in Sachsen und Brandenburg zweitstärkste Kraft geworden.
      Ihre junge Geschichte ist eine Geschichte der Flügelkämpfe,
      an deren Ende die Partei stets noch weiter nach rechts gerückt ist. 
      Umfrage-Werte laufen erstaunlich synchron zu diesen Phasen - bislang. 
      Nun driften sie in Ost und West auseinander, so stark wie nie.
    </h2>
  </div>
);

export default () => {
  const activeItemId = useActiveItem();

  if (isSmallScreen) {
    return (
      <div className="scrollapp">
        <Headline />
        <div className="chartheader">
          <ChartTitle />
        </div>
        <Chart activeItemId={activeItemId} />
        <div className="scroller">
          <div className="chronik">
            {epochs.map((epoch) => (
              <Epoch
                key={epoch.id}
                activeItemId={activeItemId}
                {...epoch}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="scrollapp">
      <div className="scroller">
        <Headline />
        <div className="chronik">
          {epochs.map((epoch) => (
            <Epoch
              key={epoch.id}
              activeItemId={activeItemId}
              {...epoch}
            />
          ))}
        </div>
      </div>
      <div className="chartcontainer">
        <Chart activeItemId={activeItemId} />
      </div>
    </div>
  );
};
